import { useRef, useState } from "react";
import { motion } from "framer-motion";
import carBg from "./images/181536-866999858.mp4";

const navLinks = [
  { label: "Start", href: "#hero" },
  { label: "Über uns", href: "#wer-wir-sind" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" },
];

const heroBullets = [
  "Unabhängige Plattform statt Autohaus",
  "Juristisch saubere Kaufverträge  statt Internet-Vorlagen",
  "Transparente Begleitung der gesamten Transaktion",
];

const heroHighlights = [
  { label: "Verträge 2024 – ohne Streitfälle", value: "312", detail: "vollständig dokumentiert" },
  { label: "Dokumenten-Checks – VIN, Eigentum, Sicherheiten", value: "100%", detail: "jede Transaktion" },
  { label: "Antwortzeit – unter 24 Stunden", value: "< 24h", detail: "verbindliche Rückmeldung" },
  { label: "Regionen – DE, AT, CH, NL, IT, ES", value: "6", detail: "juristische Partner" },
];

const notSectionCards = [
  { title: "Kein Autohaus", text: "Wir halten keinen eigenen Fahrzeugbestand." },
  {
    title: "Keine Fahrzeugbörse",
    text: "Bei uns finden Sie keine Galerie mit Fahrzeugfotos und Anzeigen.",
  },
  {
    title: "Kein Zwischenhändler im Schatten",
    text: "Wir verstecken den tatsächlichen Verkäufer nicht hinter uns.",
  },
];

const clientProfiles = [
  {
    title: "Privatkunden & Unternehmer",
    text: "Käufer, die hochwertige Fahrzeuge im In- oder Ausland erwerben und sich nicht allein auf Musterverträge verlassen möchten.",
  },
  {
    title: "Händler & Boutiquen",
    text: "Verkäufer mit ausgewählten Beständen, die komplexe Deals rechtssicher dokumentieren wollen – ohne ihre Marge offenzulegen.",
  },
  {
    title: "Vermittler & Family Offices",
    text: "Berater, die Transaktionen für Mandanten orchestrieren und sich auf belastbare Verträge, klare Kommunikation und saubere Dokumentation verlassen müssen.",
  },
];

const processSteps = [
  {
    title: "Sie haben ein Fahrzeug gefunden",
    description:
      "Sie entdecken ein Fahrzeug – beim Händler, privat, im In- oder Ausland. Sie senden uns die Anzeige, die Fahrzeugdaten oder die Kontaktdaten des Verkäufers.",
  },
  {
    title: "Prüfung von Verkäufer und Fahrzeug",
    description: "Wir prüfen:",
    bullets: [
      "Wer ist der tatsächliche Eigentümer?",
      "Gibt es Einschränkungen, Pfändungen oder Sicherungsübereignungen?",
      "Stimmen VIN, Dokumente und beschriebene Fahrzeugdaten überein?",
    ],
    extra:
      "Alle Ergebnisse werden in einem Audit-Protokoll festgehalten, sodass Sie jede Prüfung nachvollziehen und bei Bedarf mit Ihrem Anwalt teilen können.",
    footnote: "Wenn gewünscht, binden wir einen technischen Partner für eine detaillierte Fahrzeugprüfung ein.",
  },
  {
    title: "Individueller Kaufvertrag ",
    description:
      "Auf Basis der Prüfung und der getroffenen Absprachen erstellen wir einen individuellen Kaufvertrag :",
    bullets: [
      "korrekte Angaben zu Käufer, Verkäufer und Fahrzeug,",
      "klare Regelungen zu Preis, Zahlung, Übergabe und Haftung,",
      "keine versteckten Klauseln, die Ihnen unnötig Risiken aufbürden.",
    ],
    extra:
      "Der Vertrag kann zweisprachig erstellt werden und enthält kommentierte Passagen, sodass alle Parteien nachvollziehen, warum jede Klausel existiert.",
  },
  {
    title: "Begleitung der Abwicklung",
    description:
      "Wir erklären Ihnen verständlich, was genau Sie unterschreiben, und begleiten den Prozess der Zahlung und Übergabe. Auf Wunsch unterstützen wir Sie bei den nächsten Schritten – etwa Zulassung oder weiterer Dokumentation.",
    extra:
      "Zahlungs- und Übergabeschritte dokumentieren wir schriftlich, damit der Verlauf auch später noch eindeutig nachweisbar bleibt.",
  },
];

const services = [
  {
    title: "Juristischer Deal-Check",
    text: "Prüfung von Verkäufer, Dokumenten, Eigentumsverhältnissen und typischen Risiken. Sie erhalten eine klare Einschätzung, ob und unter welchen Bedingungen sich die Transaktion lohnt.",
    extra: "Entdecken wir kritische Punkte, erhalten Sie konkrete Handlungsempfehlungen inklusive Formulierungsvorschlägen.",
  },
  {
    title: "Individuelle Erstellung des Kaufvertrags ",
    text: "Kein generisches Muster aus dem Internet, sondern ein Vertrag, der Ihre konkrete Situation abbildet: Land, in dem gekauft wird, Art des Verkäufers, Währung und Art der Zahlung, besondere Vereinbarungen.",
    extra: "Jede Version des Vertrags wird versioniert gespeichert, damit Änderungen nachvollziehbar bleiben.",
  },
  {
    title: "Begleitung von Verhandlungen",
    text: "Wir helfen, Bedingungen so zu formulieren, dass sie am Ende auch im Vertrag stehen. Damit Zusagen des Verkäufers nicht nur am Telefon existieren, sondern schriftlich fixiert sind.",
    extra: "Auf Wunsch moderieren wir Gespräche mit und stellen sicher, dass jede Zusage protokolliert wird.",
  },
  {
    title: "Unterstützung bei der Abwicklung",
    text: "Empfehlungen zur sicheren Übergabe von Fahrzeug, Schlüsseln und Dokumenten, Hinweise zu Zulassung und weiteren formalen Schritten – je nach Land und Situation.",
    extra: "Auch nach Übergabe bleiben wir Ansprechpartner und vermitteln bei Bedarf weitere Spezialisten.",
  },
];

const faqs = [
  {
    question: "Sind Sie ein Autohaus oder verkaufen Sie eigene Fahrzeuge?",
    answer:
      "Nein. Wir sind keine Autohauskette und kein Händler mit eigenem Bestand. Wir begleiten Transaktionen zwischen Ihnen und dem tatsächlichen Verkäufer und sorgen für eine rechtssichere Ausgestaltung.",
  },
  {
    question: "Warum sollte ich Sie nutzen, wenn es kostenlose Vorlagen im Internet gibt?",
    answer:
      "Standardvorlagen berücksichtigen weder das Land, noch die Art des Verkäufers oder die Besonderheiten Ihres Fahrzeugs. Wir gestalten den Kaufvertrag individuell, schließen typische Lücken und weisen Sie auf Risiken hin, bevor Sie unterschreiben.",
  },
  {
    question: "Wer steht im Kaufvertrag als Verkäufer?",
    answer:
      "Im Vertrag wird der tatsächliche Verkäufer klar benannt – etwa Händler, Privatperson oder Unternehmen. Wir treten nicht als „versteckter Verkäufer“ auf, sondern als Plattform, die den Prozess strukturiert und absichert.",
  },
];

const whyBullets = [
  "Neutralität statt Verkaufsdruck – wir verdienen nicht an der Marge des Fahrzeugs.",
  "Dokumentierte Prozesse – jede Transaktion erhält ein eigenes Dossier mit den relevanten Unterlagen.",
  "Fokus auf Streitvermeidung – Verträge und Abläufe sind darauf ausgelegt, Konflikte gar nicht erst entstehen zu lassen.",
  "Erfahrung mit grenzüberschreitenden Deals – insbesondere DE, AT, CH und weitere EU-Länder.",
];

const sectionMotion = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.25 },
  transition: { duration: 0.6, ease: "easeOut" },
};

const cardHover = {
  whileHover: { scale: 1.02, y: -6 },
  transition: { type: "spring", stiffness: 150, damping: 15 },
};

const CLIP_DURATION = 3;

function App() {
  const [introDone, setIntroDone] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const backgroundVideoRef = useRef(null);
  const introVideoRef = useRef(null);

  const freezeBackgroundVideo = () => {
    const video = backgroundVideoRef.current;
    if (!video) return;

    const lockFrame = () => {
      const ranges = video.seekable;
      const hasDuration = Number.isFinite(video.duration);
      const endTime =
        (hasDuration && video.duration) ||
        (ranges && ranges.length > 0 ? ranges.end(ranges.length - 1) : null);
      const targetTime = endTime ? Math.min(endTime, CLIP_DURATION) : CLIP_DURATION;
      video.currentTime = targetTime;
      video.pause();
    };

    if (Number.isFinite(video.duration) || (video.seekable && video.seekable.length > 0)) {
      lockFrame();
    } else {
      const handleLoaded = () => {
        lockFrame();
        video.removeEventListener("loadedmetadata", handleLoaded);
      };
      video.addEventListener("loadedmetadata", handleLoaded, { once: true });
    }
  };

  const completeIntro = () => {
    if (introDone) return;
    freezeBackgroundVideo();
    setIntroDone(true);
  };

  const handleIntroTimeUpdate = (event) => {
    if (event.currentTarget.currentTime >= CLIP_DURATION) {
      event.currentTarget.pause();
      completeIntro();
    }
  };

  const handleSkipIntro = () => {
    const video = introVideoRef.current;
    if (video) {
      video.pause();
      const endTime = Number.isFinite(video.duration) ? Math.min(video.duration, CLIP_DURATION) : CLIP_DURATION;
      video.currentTime = endTime;
    }
    completeIntro();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setSubmitMessage("");
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitMessage("Danke, wir melden uns mit einer Einschätzung und dem weiteren Vorgehen.");
    }, 1600);
  };

  return (
    <>
      <div className="fixed inset-0 -z-20 overflow-hidden">
        <video ref={backgroundVideoRef} src={carBg} className="h-full w-full object-cover" autoPlay muted playsInline />
      </div>

      {!introDone && (
        <div className="fixed inset-0 z-40 overflow-hidden">
          <video
            ref={introVideoRef}
            src={carBg}
            className="h-full w-full object-cover"
            autoPlay
            muted
            playsInline
            onTimeUpdate={handleIntroTimeUpdate}
            onEnded={completeIntro}
          />
          <button
            type="button"
            onClick={handleSkipIntro}
            className="absolute bottom-8 right-8 rounded-full border border-white/20 bg-black/60 px-6 py-2 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(0,0,0,0.6)] backdrop-blur-md transition hover:bg-black/80"
          >
            Zum Inhalt
          </button>
        </div>
      )}

      <motion.div
        className="relative min-h-screen text-slate-100"
        initial={{ opacity: 0 }}
        animate={{ opacity: introDone ? 1 : 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        style={{ pointerEvents: introDone ? "auto" : "none" }}
      >
        <header className="fixed inset-x-0 top-4 z-30 flex justify-center px-4">
          <div className="flex w-full max-w-6xl items-center justify-between rounded-full border border-white/10 bg-black/55 px-6 py-3 backdrop-blur-2xl shadow-[0_18px_60px_rgba(0,0,0,0.8)]">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full border border-white/15 bg-white/5" />
              <p className="font-heading text-lg tracking-wide text-white">Neutraler Kaufvertrag</p>
            </div>
            <nav className="hidden items-center gap-6 text-sm font-medium text-slate-200 lg:flex">
              {navLinks.map((link) => (
                <a key={link.href} href={link.href} className="transition-colors hover:text-white">
                  {link.label}
                </a>
              ))}
            </nav>
            <motion.a
              href="#kontakt"
              className="rounded-full border border-sky-400/40 bg-sky-500/80 px-5 py-2 text-sm font-semibold text-white shadow-[0_0_25px_rgba(56,189,248,0.35)] transition hover:bg-sky-400 hover:shadow-[0_0_35px_rgba(56,189,248,0.6)]"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              Kontakt
            </motion.a>
          </div>
        </header>

        <main className="relative z-10 mx-auto flex max-w-6xl flex-col gap-20 px-4 pb-24 pt-32">
          <motion.section id="hero" className="w-full" {...sectionMotion}>
            <div className="rounded-[36px] border border-white/15 bg-black/30 p-10 shadow-[0_40px_110px_rgba(0,0,0,0.45)] lg:p-14">
              <div className="flex flex-col gap-12 lg:flex-row lg:items-start">
                <div className="flex flex-col gap-6 lg:basis-3/5">
                  <p className="text-sm uppercase tracking-[0.4em] text-slate-300">Start</p>
                  <h1 className="font-heading text-4xl text-white sm:text-5xl lg:text-6xl">
                    Premium-Plattform für sichere Fahrzeugkäufe.
                  </h1>
                  <p className="max-w-2xl text-lg text-slate-100">
                    Wir verkaufen keine eigenen Fahrzeuge. Wir begleiten Ihre Transaktion neutral – von der ersten Prüfung von Verkäufer und Unterlagen bis zum rechtssicheren Kaufvertrag.
                  </p>
                  <p className="text-sm text-slate-300">
                    Für Käufer, Händler und Vermittler, die Fahrzeugtransaktionen rechtssicher abwickeln wollen.
                  </p>
                  <ul className="grid gap-3 text-base text-slate-200 sm:grid-cols-2">
                    {heroBullets.map((item) => (
                      <li
                        key={item}
                        className="flex items-center gap-3 rounded-full border border-white/15 bg-black/40 px-4 py-2"
                      >
                        <span className="text-sky-400">◆</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="flex flex-wrap gap-4">
                    <motion.a
                      href="#kontakt"
                      className="rounded-full bg-sky-500/90 px-8 py-3 font-semibold text-white shadow-[0_18px_40px_rgba(14,165,233,0.45)] transition hover:bg-sky-400"
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                    >
                      Unverbindliche Beratung anfragen
                    </motion.a>
                    <a
                      href="#ablauf"
                      className="rounded-full border border-white/20 px-8 py-3 font-semibold text-white/80 transition hover:border-white/40 hover:text-white"
                    >
                      So funktioniert es
                    </a>
                  </div>
                </div>
                <motion.div
                  className="rounded-[30px] border border-white/15 bg-black/35 p-7 text-slate-200 shadow-[0_30px_90px_rgba(0,0,0,0.45)] lg:basis-2/5 lg:p-9"
                  animate={introDone ? { y: [0, -8, 0] } : { y: 0 }}
                  transition={{ duration: 6, repeat: introDone ? Infinity : 0, ease: "easeInOut" }}
                >
                  <p className="text-xs uppercase tracking-[0.4em] text-slate-400">Transaktionssicherheit</p>
                  <h3 className="mt-4 text-3xl font-semibold text-white">Dokumentiert. Neutral. Juristisch klar.</h3>
                  <p className="mt-3 text-base text-slate-200">
                    Jede Transaktion erhält ein eigenes Dossier mit Checkliste zu Dokumenten, Eigentum und Freigaben.
                    Wir erklären jede Klausel, bevor unterschrieben wird.
                  </p>
                  <div className="mt-8 grid gap-4 text-base text-slate-200 sm:grid-cols-2">
                    {heroHighlights.map((highlight) => (
                      <div key={highlight.label} className="rounded-2xl border border-white/10 bg-white/5 p-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-slate-400">{highlight.label}</p>
                        <p className="mt-1 text-2xl font-heading text-white">{highlight.value}</p>
                        <p className="text-slate-300">{highlight.detail}</p>
                      </div>
                    ))}
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.section>

          <motion.section id="wer-wir-sind" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/70 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.8)] backdrop-blur-2xl lg:p-16">
              <p className="text-sm uppercase tracking-[0.4em] text-slate-400">Wer wir sind</p>
              <h2 className="mt-2 text-3xl font-heading text-white">Wer wir sind – und was wir für Sie tun</h2>
              <div className="mt-6 space-y-4 text-lg text-slate-200">
                <p>
                  Wir sind keine klassisches Autohaus und keine Fahrzeugbörse. Unsere Rolle: Wir sind die Plattform, über die Ihre Fahrzeugtransaktion rechtssicher abgewickelt wird.
                </p>
                <p>
                  Sie finden ein Fahrzeug – über einen Händler, ein Inserat, eine Empfehlung oder im Ausland. Wir steigen dort ein, wo es kritisch wird: bei der Prüfung von Verkäufer und Fahrzeug, der Gestaltung des Kaufvertrags  und der Begleitung der eigentlichen Abwicklung.
                </p>
                <p>
                  Unser Fokus liegt nicht auf möglichst vielen Abschlüssen, sondern auf stabilen, belastbaren Transaktionen. Wir arbeiten transparent, dokumentieren alle relevanten Schritte und sind in der Kommunikation bewusst klar und direkt – auch dann, wenn wir von einem Deal abraten.
                </p>
              </div>
            </div>
          </motion.section>

          <motion.section id="was-wir-nicht-sind" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/70 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.8)] backdrop-blur-2xl lg:p-16">
              <div className="flex flex-col gap-4">
                <p className="text-sm uppercase tracking-[0.4em] text-slate-400">Abgrenzung</p>
                <h2 className="text-3xl font-heading text-white">Was wir ganz bewusst nicht sind</h2>
              </div>
              <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {notSectionCards.map((card) => (
                  <motion.div
                    key={card.title}
                    className="flex h-full flex-col gap-4 rounded-3xl border border-white/10 bg-black/65 p-7 text-slate-200 backdrop-blur-xl shadow-[0_20px_80px_rgba(0,0,0,0.65)]"
                    {...cardHover}
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-500/15 text-sky-300">▹</div>
                      <h3 className="text-lg font-semibold text-white">{card.title}</h3>
                    </div>
                    <p className="text-base text-slate-200">{card.text}</p>
                  </motion.div>
                ))}
              </div>
              <p className="mt-8 text-slate-300">
                Wir sind der Partner an Ihrer Seite, der dafür sorgt, dass Ihre Fahrzeugtransaktion klar, nachvollziehbar und rechtssicher abläuft.
              </p>
            </div>
          </motion.section>

          <motion.section id="fuer-wen" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/70 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.8)] backdrop-blur-2xl lg:p-16">
              <p className="text-sm uppercase tracking-[0.4em] text-slate-400">KUNDENPROFILE</p>
              <h2 className="mt-2 text-3xl font-heading text-white">Für wen wir arbeiten</h2>
              <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
                {clientProfiles.map((profile) => (
                  <motion.div
                    key={profile.title}
                    className="flex h-full flex-col gap-4 rounded-3xl border border-white/10 bg-white/5 p-7 text-slate-200 shadow-[0_20px_80px_rgba(0,0,0,0.65)] backdrop-blur-xl"
                    {...cardHover}
                  >
                    <h3 className="text-lg font-semibold text-white">{profile.title}</h3>
                    <p className="text-base text-slate-200">{profile.text}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.section>

          <motion.section id="ablauf" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/75 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.85)] backdrop-blur-2xl lg:p-16">
              <p className="text-sm uppercase tracking-[0.4em] text-slate-400">Wie wir arbeiten</p>
              <h2 className="mt-2 text-3xl font-heading text-white">Wie eine Transaktion über unsere Plattform abläuft</h2>
              <div className="mt-12 grid gap-8 lg:grid-cols-2">
                {processSteps.map((step, index) => (
                  <motion.div
                    key={step.title}
                    className="relative rounded-3xl border border-white/10 bg-white/5 p-8 pl-12 shadow-[0_24px_90px_rgba(0,0,0,0.65)]"
                    {...cardHover}
                  >
                    <span className="absolute left-4 top-6 h-16 w-0.5 rounded-full bg-sky-500/70" />
                    <div className="text-xs uppercase tracking-[0.4em] text-slate-400">Schritt {index + 1}</div>
                    <h3 className="mt-3 text-2xl font-semibold text-white">{step.title}</h3>
                    <p className="mt-2 text-base text-slate-200">{step.description}</p>
                    {step.bullets && (
                      <ul className="mt-4 list-disc space-y-2 pl-5 text-base text-slate-200">
                        {step.bullets.map((bullet) => (
                          <li key={bullet}>{bullet}</li>
                        ))}
                      </ul>
                    )}
                    {step.extra && <p className="mt-4 text-base text-slate-300">{step.extra}</p>}
                    {step.footnote && <p className="mt-4 text-xs text-slate-400">{step.footnote}</p>}
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.section>

          <motion.section id="leistungen" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/75 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.85)] backdrop-blur-2xl lg:p-16">
              <div className="mx-auto max-w-5xl">
                <p className="text-sm uppercase tracking-[0.4em] text-slate-400">Leistungen</p>
                <h2 className="mt-2 text-3xl font-heading text-white">Unsere Leistungen im Überblick</h2>
                <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
                  {services.map((service) => (
                    <motion.div
                      key={service.title}
                      className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-200 shadow-[0_18px_70px_rgba(0,0,0,0.65)] backdrop-blur-xl"
                      {...cardHover}
                    >
                      <h3 className="text-2xl font-semibold text-white">{service.title}</h3>
                      <p className="mt-3 text-base text-slate-200">{service.text}</p>
                      {service.extra && <p className="mt-3 text-base text-slate-200">{service.extra}</p>}
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.section>

          <motion.section id="why-us" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/75 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.85)] backdrop-blur-2xl lg:p-16">
              <p className="text-sm uppercase tracking-[0.4em] text-slate-400">WARUM</p>
              <h2 className="mt-2 text-3xl font-heading text-white">Warum unsere Plattform?</h2>
              <ul className="mt-6 space-y-4 text-sm text-slate-200">
                {whyBullets.map((bullet) => (
                  <li
                    key={bullet}
                    className="flex gap-3 rounded-2xl border border-white/10 bg-white/5 p-4 text-base text-slate-200"
                  >
                    <span className="text-sky-400">◆</span>
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.section>

          <motion.section id="faq" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/75 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.85)] backdrop-blur-2xl lg:p-16">
              <p className="text-sm uppercase tracking-[0.4em] text-slate-400">FAQ</p>
              <h2 className="mt-2 text-3xl font-heading text-white">FAQ</h2>
              <div className="mt-8 space-y-6">
                {faqs.map((faq) => (
                  <motion.div
                    key={faq.question}
                    className="rounded-3xl border border-white/10 bg-white/5 p-7 text-slate-200 backdrop-blur-xl"
                    {...cardHover}
                  >
                    <p className="text-lg font-semibold text-white">{faq.question}</p>
                    <p className="mt-2 text-base text-slate-300">{faq.answer}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.section>

          <motion.section id="kontakt" className="w-full" {...sectionMotion}>
            <div className="rounded-[32px] border border-white/10 bg-black/80 p-10 shadow-[0_30px_120px_rgba(0,0,0,0.9)] backdrop-blur-2xl lg:p-16">
              <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr]">
                <div>
                  <p className="text-sm uppercase tracking-[0.4em] text-slate-400">Kontakt</p>
                  <h2 className="mt-3 text-3xl font-heading text-white">Sprechen Sie mit uns</h2>
                  <p className="mt-4 text-lg text-slate-200">
                    Teilen Sie uns das gewünschte Fahrzeug, den Verkäufer und Ihre Fragen mit. Wir melden uns mit einer Einschätzung und dem weiteren Vorgehen.
                  </p>
                  <div className="mt-8 grid gap-4 text-base text-slate-300 sm:grid-cols-2">
                    <div className="rounded-2xl border border-white/5 bg-white/5 p-4 backdrop-blur-lg">
                      <p className="text-xs uppercase tracking-[0.3em] text-slate-400">E-Mail</p>
                      <a
                        href="mailto:consalting@autopartner-de.com"
                        className="mt-1 inline-flex text-white transition hover:text-sky-300 hover:underline"
                      >
                        consalting@autopartner-de.com
                      </a>
                    </div>
                    <div className="rounded-2xl border border-white/5 bg-white/5 p-4 backdrop-blur-lg">
                      <p className="text-xs uppercase tracking-[0.3em] text-slate-400">Telefon</p>
                      <a href="tel:+49300002121" className="mt-1 inline-flex text-white transition hover:text-sky-300 hover:underline">
                        +49 163 017 91 27
                      </a>
                    </div>
                  </div>
                </div>
                <form className="space-y-4" onSubmit={handleSubmit}>
                  <label className="text-sm text-slate-200">
                    Name
                    <input
                      type="text"
                      name="name"
                      placeholder="Ihr Name"
                      className="mt-2 w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-base text-white placeholder:text-slate-400 focus:border-sky-400 focus:outline-none"
                      required
                    />
                  </label>
                  <label className="text-sm text-slate-200">
                    E-Mail
                    <input
                      type="email"
                      name="email"
                      placeholder="beispiel@mail.de"
                      className="mt-2 w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-base text-white placeholder:text-slate-400 focus:border-sky-400 focus:outline-none"
                      required
                    />
                  </label>
                  <label className="text-sm text-slate-200">
                    Nachricht
                    <textarea
                      name="message"
                      rows={5}
                      placeholder="Beschreiben Sie kurz Ihr Anliegen"
                      className="mt-2 w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-base text-white placeholder:text-slate-400 focus:border-sky-400 focus:outline-none"
                      required
                    />
                  </label>
                  <motion.button
                    type="submit"
                    className="w-full rounded-full bg-sky-500/90 px-6 py-3 text-base font-semibold text-white shadow-[0_18px_40px_rgba(14,165,233,0.45)] transition hover:bg-sky-400 disabled:cursor-not-allowed disabled:opacity-60"
                    whileHover={{ scale: isSubmitting ? 1 : 1.03 }}
                    whileTap={{ scale: isSubmitting ? 1 : 0.97 }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Wird gesendet…" : "Nachricht senden"}
                  </motion.button>
                  {submitMessage && <p className="text-sm text-slate-200">{submitMessage}</p>}
                </form>
              </div>
            </div>
          </motion.section>
        </main>
      </motion.div>
    </>
  );
}

export default App;

